import type { FaireProductEntity } from "../../entity_types/product";

export const p_w3xyykrc2y: FaireProductEntity = {
  token: "p_w3xyykrc2y",
  type: "product",
  name: "Mahjong Shimmer Sheer Crew Sock",
  brandToken: "b_2z2c37uymf",
  brandName: "Sock Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/aff37c8ec5b0482a2fc62e5678faa553752e0c5802569ef47d2ca497b0265a81.png",
  galleryImageUrls: [],
  priceDollars: 9,
  description:
    "Fall 2026 Collection - AVAILABLE FOR PRE-ORDER.\n\n\n\nOne Size. Recommended fit US women's shoe sizes 5.5-10\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:36.326Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
